export default __webpack_public_path__ + "static/media/new-window.4baa307b.svg";